export default function Loader() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '75vh', padding: 60 }}>
            <div className="spinner" style={{ width: 36, height: 36, borderColor: 'rgba(107,33,168,0.2)', borderTopColor: 'var(--purple-800)' }} />
        </div>
    )
}
